"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsensusRunDeadEndedEvent = exports.ConsensusDeadEndReason = exports.ConsensusDeadEndStatus = exports.ConsensusAutoAcceptResolutionWrittenEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
exports.ConsensusAutoAcceptResolutionWrittenEvent = (0, event_1.createEventClass)('ConsensusAutoAcceptResolutionWrittenEvent', zod_1.z.object({
    packageId: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    pinCount: zod_1.z.number().int(),
    planId: zod_1.z.string(),
    consensusRunId: zod_1.z.string(),
}));
var ConsensusDeadEndStatus;
(function (ConsensusDeadEndStatus) {
    ConsensusDeadEndStatus["Ineligible"] = "ineligible";
    ConsensusDeadEndStatus["RecordedShadow"] = "recorded_shadow";
})(ConsensusDeadEndStatus || (exports.ConsensusDeadEndStatus = ConsensusDeadEndStatus = {}));
var ConsensusDeadEndReason;
(function (ConsensusDeadEndReason) {
    ConsensusDeadEndReason["NoSubmissions"] = "no_submissions";
    ConsensusDeadEndReason["AutoAcceptWriteDisabled"] = "auto_accept_write_disabled";
    ConsensusDeadEndReason["SpawnDisabled"] = "spawn_disabled";
})(ConsensusDeadEndReason || (exports.ConsensusDeadEndReason = ConsensusDeadEndReason = {}));
exports.ConsensusRunDeadEndedEvent = (0, event_1.createEventClass)('ConsensusRunDeadEndedEvent', zod_1.z.object({
    packageId: zod_1.z.string().nullable(),
    planId: zod_1.z.string(),
    status: zod_1.z.nativeEnum(ConsensusDeadEndStatus),
    trigger: zod_1.z.string(),
    submissionCount: zod_1.z.number().int().nonnegative().optional(),
    reason: zod_1.z.nativeEnum(ConsensusDeadEndReason),
}));
//# sourceMappingURL=consensus-events.js.map